import Vue from 'vue';
import SideNavBarQuestionLink from '@/components/navigation/SideNavBarQuestionLink.vue';

Vue.component('side-bar-question-link', SideNavBarQuestionLink);
